<cc-dashboard-page-container>
  <ng-container title>
    {{ 'spot-configuration.LIST_TITLE' | transloco }}
  </ng-container>

  <cc-table-preview page-content>
    <cc-table-container [isLoading]="isLoading$ | async">
      <div table-buttons class="flex flex-col sm:flex-row">
        <cc-add-action-button (onClick)="add()"></cc-add-action-button>
      </div>

      <bo-mat-table
        #table
        matSort
        [data]="settingSpotConfigurations$ | async"
        (matSortChange)="onSort($event)"
        (pageChange)="setPage($event)"
      >
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'spot-configuration.spot-configuration-identifier.fields.COUNTRY'
                | transloco
            }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ 'bo.common.countries.' + element.country | transloco }}
          </td>
        </ng-container>

        <ng-container matColumnDef="energySource">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'spot-configuration.spot-configuration-identifier.fields.ENERGY_SOURCE'
                | transloco
            }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ 'bo.common.energysources.' + element.energySource | transloco }}
          </td>
        </ng-container>

        <ng-container matColumnDef="stockMarket">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
              'spot-configuration.spot-configuration-identifier.fields.STOCK_MARKET'
                | transloco
            }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.stockMarket }}
          </td>
        </ng-container>
      </bo-mat-table>
    </cc-table-container>
  </cc-table-preview>
</cc-dashboard-page-container>
